export default "__VITE_ASSET__D9usz6Sm__"